import React from 'react';
import { useTranslation } from 'react-i18next';

import { LabeledSelect } from '../Input/LabeledSelect';

const UnitOfVolumeSelect = ({ allowClear = true,
  disabled, ...props }) => {
  const [ t ] = useTranslation();

  return (
    <LabeledSelect
      placeholder={ t('fields.choose') }
      { ...props }
      disabled={ disabled }
      allowClear={ allowClear }
      options={ [
        { text: 'DF', value: '1' },
        { text: 'g', value: '2' },
        { text: 'gm', value: '3' },
        { text: 'IU', value: '4' },
        { text: 'l', value: '5' },
        { text: 'mg', value: '6' },
        { text: 'ml', value: '7' }
      ] }
    />
  );
};
export default UnitOfVolumeSelect;
